import { Injectable } from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import moment from "moment";
import { DatePipe } from "@angular/common";
import { InsertDownloadLogGQL } from '../generated/cloudapigql';

@Injectable()
export class SharedService {
    public header: any = {};
    public footer: any = {};
    public sideNav: MatSidenav;
    Dateformats:any []=[
        moment.ISO_8601
    ];

    constructor(private insertDownloadLogGQL : InsertDownloadLogGQL){
    }

    insertDownloadLog(fileName:string,fileSize:number,path:string,attachmentId?:string){
        return this.insertDownloadLogGQL.mutate({
            attachmentId:attachmentId,
            path:path,
            fileName:fileName,
            fileSize:fileSize
        });
    }

    UnitOfMeterMeasurement(itemCode: string) {
        switch (itemCode) {
            case "MeterType_Water": {
                return "Litres"
            }
            case "MeterType_Electric": {
                return "kWh"
            }
            case "MeterType_Gas": {
                return "Litres"
            }
            case "MeterType_Time": {// this is other type in the mall system
                return " "
            }
            default: {
                break;
            }
        }
    }

    CreateDatePipeString(data: any[]) {
        for(let item of data){
            let keys = Object.keys(item);
            for(let k of keys){
                if (moment(item[k], this.Dateformats, true).isValid()) {
                    const datePipe = new DatePipe('en-US');
                    item[`${k}Text`] = datePipe.transform(item[k], 'dd MMM yyyy');
                }
            }
        }
    }

    getAttachmentIconDisplay(fileName: string, includeMedia: boolean = false) {
        //default is other
        let result = "assets/images/icon/other-file.svg";
        if(fileName){
            let tempArr = fileName.split(".");
            let tempExt = tempArr[tempArr.length - 1 < 0 ? 0 : tempArr.length - 1]?.toLowerCase();
    
            if (tempExt == "pdf") {
                result = "assets/images/icon/pdf-icon.svg";
    
            } else if (tempExt == "doc" || tempExt == "docx" || tempExt == "odt" || tempExt == "rtf") {
                result = "assets/images/icon/word-icon.svg";
    
            } else if (tempExt == "xlsx" || tempExt == "xls" || tempExt == "ods") {
                result = "assets/images/icon/excel-icon.svg";
    
            } else if (tempExt == "jpg" || tempExt == "ico" || tempExt == "gif" || tempExt == "png" || tempExt == "svg" || tempExt == "tiff" || tempExt == "webp") {
                result = "assets/images/icon/jpg-icon.svg";
    
            } else if (tempExt == "ppt" || tempExt == "pptx" || tempExt == "odp") {
                result = "assets/images/icon/ppt-icon.svg";
    
            } else if (tempExt == "mov" || tempExt == "mp4" ) {
                if (includeMedia) {
                    result = "assets/images/icon/vid-icon.svg";
                } else {
                    result = "assets/images/icon/video-placeholder.jpg";
                }
            } else if (tempExt == "zip" || tempExt == "zipx" || tempExt == "rar" || tempExt == "tar" || tempExt == "rar" || tempExt == "7z" || tempExt == "war") {
                result = "assets/images/icon/zip-icon.svg";
            }
        }
        return result;
    }

    dynamicContentMargin() {
        var height = parseInt($(".fixed-subheader").css("height"));
        var dynamicMargintop = height + 6;
        $(".with-fixed-subheader-dynamic").css(
          "margin-top",
          `${dynamicMargintop}px`
        );
    }
    
    getDateString(date: Date, withTime: boolean = true) {
        if (date) {
            let tempMonth = ("0" + (date.getMonth() + 1).toString()).slice(-2);
            let tempDate = ("0" + (date.getDate()).toString()).slice(-2);
            let tempHours = "00"
            let tempMinutes = "00"
            let tempSeconds = "00"

            if (withTime) {
                tempHours = ("0" + (date.getHours()).toString()).slice(-2);
                tempMinutes = ("0" + (date.getMinutes()).toString()).slice(-2);
                tempSeconds = ("0" + (date.getSeconds()).toString()).slice(-2);
            }

            const result = `${date.getFullYear()}-${tempMonth}-${tempDate} ${tempHours}:${tempMinutes}:${tempSeconds}`;

            return result;
        } else {
            return null;
        }
    }
}
